<a  class="overlay-sidebar-header" [class.overlay-sidebar-header-open]="openSide" (click)="closeOverlay()"></a>
<div class="responsive-btn float-right"><a (click)="toggleSidebar()"><i class="fa fa-bars" aria-hidden="true"></i></a></div>
<div class="navbar ml-md-auto ml-lg-0 res-width" id="togglebtn" [class.openSidebar]="openSide">
    <div class="responsive-btn">
        <a (click)="toggleSidebar()"><h5>back</h5></a>
    </div>
    <ul class="navbar-nav">
      <li *ngFor="let menuItem of menuItems" [class]="menuItem.megaMenu ? 'mega-menu' : ''">
            <a routerLinkActive="active" class="dropdown" *ngIf="menuItem.type === 'link'" (click)="setActive(menuItem.title, menuItem.path)">
                {{menuItem.title}}
            </a>
        </li>
    </ul>
  </div>
